export const cubicBezier = "cubic-bezier(0.15, 0.15, 0, 1)"

export const timings = {
  quick: "100ms",
  medium: "250ms",
  long: "500ms",
}
